import auth from "./auth.json";
import orders from "./orders.json";
import apiIntegration from "./api-integration.json";
import settings from "./settings.json";
import types from "./types.json";
import createEditOrderNew from "./createEditOrderNew.json";
import components from "./components.json";

// eslint-disable-next-line
export default {
  auth,
  orders,
  apiIntegration,
  settings,
  types,
  createEditOrderNew,
  components,
};
